var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6647_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83338 51.0391H13.125C16.3466 51.0391 18.9584 53.6507 18.9584 56.8724V64.1641C18.9584 67.3858 16.3466 69.9974 13.125 69.9974H5.83338C2.61174 69.9974 0 67.3858 0 64.1641V56.8724C0 53.6508 2.61174 51.0391 5.83338 51.0391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4249 52.0366C66.4626 51.3847 65.3264 51.0372 64.1641 51.0391H56.8724C53.6508 51.0391 51.0391 53.6507 51.0391 56.8724V64.1641C51.0391 67.3858 53.6508 69.9974 56.8724 69.9974H64.1641C67.3858 69.9974 69.9974 67.3858 69.9974 64.1641V56.8724C69.9972 54.9331 69.033 53.1207 67.4249 52.0366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83338 25.5234H13.125C16.3466 25.5234 18.9584 28.1352 18.9584 31.3568V38.6484C18.9584 41.8701 16.3466 44.4818 13.125 44.4818H5.83338C2.61174 44.4817 0 41.8701 0 38.6484V31.3568C0 28.135 2.61174 25.5234 5.83338 25.5234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4249 26.5209C66.4626 25.8691 65.3264 25.5215 64.1641 25.5234H56.8724C53.6508 25.5234 51.0391 28.1352 51.0391 31.3568V38.6484C51.0391 41.8701 53.6508 44.4818 56.8724 44.4818H64.1641C67.3857 44.4818 69.9974 41.8701 69.9974 38.6484V31.3568C69.9972 29.4173 69.033 27.605 67.4249 26.5209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83338 0H13.125C16.3466 0 18.9584 2.61174 18.9584 5.83338V13.125C18.9584 16.3466 16.3466 18.9584 13.125 18.9584H5.83338C2.61174 18.9584 0 16.3466 0 13.125V5.83338C0 2.61174 2.61174 0 5.83338 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9093 52.0366C40.947 51.3847 39.8108 51.0372 38.6484 51.0391H31.3568C28.1352 51.0391 25.5234 53.6507 25.5234 56.8724V64.1641C25.5234 67.3857 28.1352 69.9974 31.3568 69.9974H38.6484C41.8701 69.9974 44.4818 67.3858 44.4818 64.1641V56.8724C44.4815 54.9331 43.5174 53.1207 41.9093 52.0366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9093 26.5209C40.947 25.8691 39.8108 25.5215 38.6484 25.5234H31.3568C28.1352 25.5234 25.5234 28.1352 25.5234 31.3568V38.6484C25.5234 41.8701 28.1352 44.4818 31.3568 44.4818H38.6484C41.8701 44.4818 44.4818 41.8701 44.4818 38.6484V31.3568C44.4815 29.4173 43.5174 27.605 41.9093 26.5209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9093 0.997508C40.947 0.345633 39.8108 -0.0019062 38.6484 7.86386e-06H31.3568C28.1352 7.86386e-06 25.5234 2.61175 25.5234 5.83339V13.125C25.5234 16.3466 28.1352 18.9584 31.3568 18.9584H38.6484C41.8701 18.9584 44.4818 16.3466 44.4818 13.125V5.83339C44.4815 3.89403 43.5174 2.08155 41.9093 0.997508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9999 2.5725C67.9159 0.964414 66.1034 0.000273438 64.1641 0H56.8724C53.6508 0 51.0391 2.61174 51.0391 5.83338V13.125C51.0391 16.3466 53.6508 18.9584 56.8724 18.9584H64.1641C67.3858 18.9584 69.9974 16.3466 69.9974 13.125V5.83338C69.9994 4.671 69.6518 3.53486 68.9999 2.5725Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6647_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveGrid);
export default __webpack_public_path__ + "static/media/active-grid.45348571455683de609284ad7d138bda.svg";
export { ForwardRef as ReactComponent };